import {
	ClientPortfolioDomainEnum,
	type ClientPropertyItemResponseDTO,
	type PortfolioListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

export const PortfolioCategoryIds = {
	property: "property",
	uncategorized: "uncategorized",
} as const;

export type PortfolioCategoryId =
	| ClientPortfolioDomainEnum
	| (typeof PortfolioCategoryIds)[keyof typeof PortfolioCategoryIds];

export type PortfolioArea =
	| ClientPortfolioDomainEnum
	| typeof PortfolioCategoryIds.property;

export const PORTFOLIO_CATEGORY_ORDER: PortfolioCategoryId[] = [
	ClientPortfolioDomainEnum.LifeInsurance,
	ClientPortfolioDomainEnum.PropertyInsurance,
	ClientPortfolioDomainEnum.PensionProducts,
	ClientPortfolioDomainEnum.BuildingSavings,
	ClientPortfolioDomainEnum.Investments,
	ClientPortfolioDomainEnum.BusinessLoans,
	ClientPortfolioDomainEnum.Loans,
	ClientPortfolioDomainEnum.Leasing,
	ClientPortfolioDomainEnum.Commodities,
	ClientPortfolioDomainEnum.BankingProducts,
	ClientPortfolioDomainEnum.Cryptocurrencies,
	ClientPortfolioDomainEnum.Services,
	PortfolioCategoryIds.property,
	PortfolioCategoryIds.uncategorized,
];

export type CategoryItem =
	| { kind: PortfolioItemKind.Portfolio; data: PortfolioListItemResponseDTO }
	| { kind: PortfolioItemKind.Property; data: ClientPropertyItemResponseDTO };

export type PortfolioCategory = {
	id: PortfolioCategoryId;
	items: CategoryItem[];
};
